import { render, staticRenderFns } from "./RiscossioneFilter.vue?vue&type=template&id=43cb3a51&"
import script from "./RiscossioneFilter.vue?vue&type=script&lang=ts&"
export * from "./RiscossioneFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports